module.exports = __webpack_public_path__ + "static/media/round2.d356337f.jpeg";